import React from 'react';
import PublicLayout from './PublicLayout';
import PrivateLayout from './PrivateLayout';
import ErrorLayout from './ErrorLayout';


interface IProps {
    layoutType: 'public' | 'private' | 'error'
    children: React.ReactNode
}

let Layout = ({ layoutType, children }: IProps) => {
    return (
        <>
            {layoutType === 'public' &&
                <PublicLayout>{children}</PublicLayout>
            }
            {layoutType === 'private' &&
                <PrivateLayout>{children}</PrivateLayout>
            }
            {layoutType === 'error' &&
                <ErrorLayout>{children}</ErrorLayout>
            }
        </>
    )
}

export default Layout;